module.exports = __webpack_public_path__ + "static/media/Keeper-K_White.1e40401f.svg";